/**
 * Permissions (should be in sync with API permissions in seed data)
 */

export const ADMIN_TOOL_VIEW = 'ADMIN_TOOL:VIEW';
export const INTERNAL_MANAGE_ORG_PARAMS = 'INTERNAL:MANAGE_ORG_PARAMS';
export const DEMO_VIEW = 'DEMO:VIEW';
export const COACH_VIEW = 'EXPERIENCE_PLATFORM_COACH:VIEW';
export const LEARNING_VIEW = 'EXPERIENCE_PLATFORM_LEARNING:VIEW';
